import axios from '../../../../utils/request';

function GET_NUM(params) {
    return axios.get("/statistics/ActiveWebsite/websiteStatistics",{
        params: {
            page:params
        }
    } )
}
function GET_LIST(params) {
    return  axios.get("/statistics/ActiveWebsite/loginRanking",{
        params:{ ...params}
    } )
}
function EXPORT(params) {
    return  axios.get("/statistics/ActiveWebsite/loginRankingExport",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    GET_NUM,
    EXPORT,
};
